export class ExpressionLanguageUtile {
  static evaluate(expression: string, context: Record<string, any>): boolean | null {
    try {
      // Create a new function with the expression and context
      const func = new Function(...Object.keys(context), `return ${expression};`);
      // Call the function with the context values
      return func(...Object.values(context));
    } catch (error) {
      console.error('Error evaluating expression:', error);
      return null; // or handle the error as needed
    }
  }
}
